<template>
<div class="navbar-container">

<nav class="navbar">
  <ul class="navbar__menu">
    <li v-if="true" class="navbar__item">
      <router-link to="/TripSheetDashboard" style="text-decoration: none; color: inherit;">
        <div class="navbar__link">
            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path d="M17,24H7c-2.757,0-5-2.243-5-5V5C2,2.243,4.243,0,7,0h10c2.757,0,5,2.243,5,5v14c0,2.757-2.243,5-5,5ZM7,2c-1.654,0-3,1.346-3,3v14c0,1.654,1.346,3,3,3h10c1.654,0,3-1.346,3-3V5c0-1.654-1.346-3-3-3H7Zm11,4c0-.552-.448-1-1-1h-4c-.552,0-1,.448-1,1s.448,1,1,1h4c.552,0,1-.448,1-1Zm0,6c0-.552-.448-1-1-1h-4c-.552,0-1,.448-1,1s.448,1,1,1h4c.552,0,1-.448,1-1Zm0,6c0-.552-.448-1-1-1h-4c-.552,0-1,.448-1,1s.448,1,1,1h4c.552,0,1-.448,1-1ZM10,7v-2c0-.552-.448-1-1-1h-2c-.552,0-1,.448-1,1v2c0,.552,.448,1,1,1h2c.552,0,1-.448,1-1Zm0,6v-2c0-.552-.448-1-1-1h-2c-.552,0-1,.448-1,1v2c0,.552,.448,1,1,1h2c.552,0,1-.448,1-1Zm0,6v-2c0-.552-.448-1-1-1h-2c-.552,0-1,.448-1,1v2c0,.552,.448,1,1,1h2c.552,0,1-.448,1-1Z"/></svg>
            <span>Trip Dashboard</span>
        </div>      
      </router-link>
    </li>
  </ul>
</nav>

</div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
* {
  --border-radius: 10px;
  --spacer: 1rem;
  --primary: #0ca7db;
  --text: #6a778e;
  --link-height: calc(var(--spacer) * 3.5);
  --timing: 250ms;
  --transition: var(--timing) ease all;
}

@keyframes gooeyEffect {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(0.5, 1.5);
  }
  100% {
    transform: scale(1, 1);
  }
}

li{
    list-style: none;
}

svg{
    height: 2rem;
    margin: 0;
    padding: 2.5px;
}

body {
  background: #eaeef6;
  font-family: 'Open Sans', sans-serif;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.navbar-container{
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.navbar {
  /* margin-top: 180px; */
  position: relative;
  margin-top: 20px;
  background: #fff;
  border-radius: var(--border-radius);
  padding: 2.5px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  height: fit-content;
  width: fit-content;
  z-index: 9;
}

.navbar__link {
    padding-left: 1rem;
    padding-right: 1rem;
    margin: 1px;
  position: relative;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--link-height);
  color: var(--text);
  transition: var(--transition);
  border-radius: 5px;
  cursor: pointer;
}

.navbar__link span {
  position: absolute;
  top: 100%;
  left: 0;
  transform: translateY(calc(-1 * var(--spacer) * 3));
  margin-top: .5rem;
  opacity: 0;
  pointer-events: none;
  color: #000;
  background: #f2f2f2;
  padding: calc(var(--spacer) * 0.75);
  transition: var(--transition);
  border-radius: calc(var(--border-radius) * 1.75);
}

.navbar__link:hover {
  color: #f2f2f2;
  background-color: #32ccfe;
}

.navbar:not(:hover) .navbar__link:focus,
.navbar__link:hover span {
  opacity: 1;
  transform: translateY(0);
}

.navbar__menu {
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 100%;
    padding: 0;
    margin: 0;
    position: relative;
}
</style>